__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "host";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@oy-global-web/analytics", "0.0.0", () => (__webpack_require__.e(1435).then(() => (() => (__webpack_require__(1435))))));
			register("@oy-global-web/constants", "0.0.0", () => (__webpack_require__.e(6909).then(() => (() => (__webpack_require__(6909))))));
			register("@oy-global-web/design-system", "0.0.0", () => (__webpack_require__.e(4733).then(() => (() => (__webpack_require__(4733))))));
			register("@oy-global-web/hooks", "0.0.0", () => (__webpack_require__.e(2093).then(() => (() => (__webpack_require__(2093))))));
			register("@oy-global-web/store", "0.0.0", () => (__webpack_require__.e(9210).then(() => (() => (__webpack_require__(9210))))));
			register("@oy-global-web/types", "0.0.0", () => (__webpack_require__.e(4868).then(() => (() => (__webpack_require__(4868))))));
			register("@oy-global-web/utils", "0.0.0", () => (__webpack_require__.e(9441).then(() => (() => (__webpack_require__(9441))))));
			register("@tanstack/react-query", "5.55.3", () => (Promise.all([__webpack_require__.e(4510), __webpack_require__.e(35)]).then(() => (() => (__webpack_require__(4510))))));
			register("@tanstack/react-router", "1.120.15", () => (Promise.all([__webpack_require__.e(1501), __webpack_require__.e(5470)]).then(() => (() => (__webpack_require__(1501))))));
			register("@vanilla-extract/dynamic", "2.1.2", () => (__webpack_require__.e(4957).then(() => (() => (__webpack_require__(4957))))));
			register("axios", "1.8.1", () => (__webpack_require__.e(6963).then(() => (() => (__webpack_require__(6963))))));
			register("clsx", "2.1.1", () => (__webpack_require__.e(4357).then(() => (() => (__webpack_require__(4357))))));
			register("dayjs", "1.11.13", () => (__webpack_require__.e(2981).then(() => (() => (__webpack_require__(2981))))));
			register("dompurify", "3.2.6", () => (__webpack_require__.e(7519).then(() => (() => (__webpack_require__(7519))))));
			register("embla-carousel-react", "8.6.0", () => (__webpack_require__.e(4198).then(() => (() => (__webpack_require__(4198))))));
			register("embla-carousel", "8.6.0", () => (__webpack_require__.e(7792).then(() => (() => (__webpack_require__(7792))))));
			register("es-toolkit", "1.33.0", () => (__webpack_require__.e(1531).then(() => (() => (__webpack_require__(1531))))));
			register("he", "1.2.0", () => (__webpack_require__.e(9119).then(() => (() => (__webpack_require__(9119))))));
			register("qs", "6.14.0", () => (Promise.all([__webpack_require__.e(8281), __webpack_require__.e(6973)]).then(() => (() => (__webpack_require__(8281))))));
			register("react-dom", "19.0.3", () => (__webpack_require__.e(8485).then(() => (() => (__webpack_require__(8485))))));
			register("react-error-boundary", "5.0.0", () => (__webpack_require__.e(2725).then(() => (() => (__webpack_require__(2725))))));
			register("react-router", "7.9.4", () => (Promise.all([__webpack_require__.e(2215), __webpack_require__.e(1879)]).then(() => (() => (__webpack_require__(2215))))));
			register("react", "19.0.3", () => (__webpack_require__.e(7552).then(() => (() => (__webpack_require__(7552))))));
			register("swiper/modules", "11.2.10", () => (Promise.all([__webpack_require__.e(6853), __webpack_require__.e(8771)]).then(() => (() => (__webpack_require__(6853))))));
			register("uuid", "13.0.0", () => (__webpack_require__.e(5049).then(() => (() => (__webpack_require__(5049))))));
			register("zustand", "5.0.3", () => (__webpack_require__.e(2393).then(() => (() => (__webpack_require__(2393))))));
			initExternal(9126);
			initExternal(577);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};